/**
 * 将像素值转换为vw单位
 * @param px 像素值
 * @param viewportWidth 视口宽度，默认375（与postcss.config.js中的配置保持一致）
 * @returns vw字符串
 */
export function px2vw(px: number, viewportWidth = 375): string {
  return `${(px / viewportWidth) * 100}vw`;
}

/**
 * 将像素值转换为vw数值（不带单位）
 * @param px 像素值
 * @param viewportWidth 视口宽度，默认375
 * @returns vw数值
 */
export function px2vwValue(px: number, viewportWidth = 375): number {
  return (px / viewportWidth) * 100;
}
